export const appSettingsAppGroupIdMessagePrioritizationCategoryCategoryIdDependencies =
  "/app_settings/:app_group_id/message_prioritization/category/:category_id/dependencies";
